import React, { useRef, useEffect, useState } from "react";

export default function ProgressBar({ progress }) {
    const barRef = useRef(null);
    const [, setBarWidth] = useState(0);

    useEffect(() => {
        const updateWidth = () => {
            if (barRef.current) {
                setBarWidth(barRef.current.offsetWidth);
            }
        };

        updateWidth();
        window.addEventListener("resize", updateWidth);
        return () => window.removeEventListener("resize", updateWidth);
    }, []);

    return (
        <div className="w-screen mt-0">
            <div
                ref={barRef}
                className="relative w-full h-2 bg-secondary rounded-full"
                role="progressbar"
                aria-valuemin={0}
                aria-valuemax={100}
                aria-valuenow={progress}
                aria-label={`התקדמות השאלון: ${progress}%`}
            >
                <div
                    className="h-full bg-accent transition-all duration-300 ease-in-out rounded-full"
                    style={{ width: `${progress}%` }}
                />
                <div
                    className="absolute top-1/2 transform -translate-y-1/2 w-4 h-4 rounded-full border-2 border-white bg-highlight shadow-md transition-all duration-300"
                    style={{
                        right: `calc(${progress}% - 8px)`
                    }}
                />
            </div>
        </div>
    );
}